import { Info } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';
import { Tooltip } from '@work4all/components/lib/components/tooltip/Tooltip';
import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';
import { CheckboxRadioItem } from '@work4all/components/lib/input/checkbox-radio-item';

import { ControllerPlus } from '../../../../../containers/mask-overlays/form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../containers/mask-overlays/form-plus/use-form-context-plus';
import { ControlWrapper } from '../../../../../containers/mask-overlays/mask-overlay/components';
import { ProjectHourBillingOverlayFormValue } from '../types';

export const ProjectHourBillingOverlayMiscellaneous = () => {
  const { t } = useTranslation();
  const { control } = useFormContextPlus<ProjectHourBillingOverlayFormValue>();

  return (
    <Collapse title={t('MASK.MISCELLANEOUS')} defaultOpen>
      <ControlWrapper columns={2}>
        <Box>
          <Divider title={t('COMMON.HEADER_TEXT')} />

          <ControllerPlus
            control={control}
            name="settings"
            render={({ field: { value, ...rest } }) => (
              <CheckboxRadioItem
                {...rest}
                label={t('COMMON.ORDER_REFERENCE')}
                checked={value.headerShowOrderReference}
                onChange={(e) => {
                  rest.onChange({
                    ...value,
                    headerShowOrderReference: e.target.checked,
                  });
                }}
              />
            )}
          />

          <ControllerPlus
            control={control}
            name="settings"
            render={({ field: { value, ...rest } }) => (
              <CheckboxRadioItem
                {...rest}
                label={t('COMMON.PROJECT_REFERENCE')}
                checked={value.headerShowProjectReference}
                onChange={(e) => {
                  rest.onChange({
                    ...value,
                    headerShowProjectReference: e.target.checked,
                  });
                }}
              />
            )}
          />

          <ControllerPlus
            control={control}
            name="settings"
            render={({ field: { value, ...rest } }) => (
              <CheckboxRadioItem
                {...rest}
                label={t('COMMON.PERFORMANCE_PERIOD')}
                checked={value.headerShowTimespan}
                onChange={(e) => {
                  rest.onChange({
                    ...value,
                    headerShowTimespan: e.target.checked,
                  });
                }}
              />
            )}
          />
        </Box>

        <Box>
          <Divider title={t('COMMON.POSITIONS')} />
          <ControllerPlus
            control={control}
            name="settings"
            render={({ field: { value, ...rest } }) => (
              <CheckboxRadioItem
                {...rest}
                label={t('COMMON.ORDER_REFERENCE')}
                checked={value.positionShowOrderReference}
                onChange={(e) => {
                  rest.onChange({
                    ...value,
                    positionShowOrderReference: e.target.checked,
                  });
                }}
              />
            )}
          />

          <ControllerPlus
            control={control}
            name="settings"
            render={({ field: { value, ...rest } }) => (
              <CheckboxRadioItem
                {...rest}
                label={t('PROJECT_BILLING.POSITION_ADD_DATE')}
                checked={value.positionAddDate}
                onChange={(e) => {
                  rest.onChange({
                    ...value,
                    positionAddDate: e.target.checked,
                  });
                }}
              />
            )}
          />

          <ControllerPlus
            control={control}
            name="settings"
            render={({ field: { value, ...rest } }) => (
              <CheckboxRadioItem
                {...rest}
                label={t('PROJECT_BILLING.POSITION_ADD_ARTICLE_DESCRIPTION')}
                checked={value.positionAddArticleDescription}
                onChange={(e) => {
                  rest.onChange({
                    ...value,
                    positionAddArticleDescription: e.target.checked,
                  });
                }}
              />
            )}
          />

          <ControllerPlus
            control={control}
            name="settings"
            render={({ field: { value, ...rest } }) => (
              <CheckboxRadioItem
                {...rest}
                label={t('PROJECT_BILLING.POSITION_ADD_USER')}
                checked={value.positionAddUser}
                onChange={(e) => {
                  rest.onChange({
                    ...value,
                    positionAddUser: e.target.checked,
                  });
                }}
              />
            )}
          />

          <ControllerPlus
            control={control}
            name="settings"
            render={({ field: { value, ...rest } }) => (
              <Stack direction="row" alignItems="center" gap={1}>
                <CheckboxRadioItem
                  {...rest}
                  label={t('PROJECT_BILLING.POSITION_ADD_COMMENT')}
                  checked={value.positionAddComment}
                  onChange={(e) => {
                    rest.onChange({
                      ...value,
                      positionAddComment: e.target.checked,
                    });
                  }}
                />
                <Tooltip
                  title={t('PROJECT_BILLING.POSITION_ADD_COMMENT_TOOLTIP')}
                >
                  <Info color="primary" />
                </Tooltip>
              </Stack>
            )}
          />
        </Box>
      </ControlWrapper>
    </Collapse>
  );
};
